import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import styled from 'styled-components';
import {MainLayout, InnerLayout} from '../styles/Layouts';
import Title from '../Components/Title';
import PrimaryButton from '../Components/PrimaryButton';
import PhoneIcon from '@material-ui/icons/Phone';
import EmailIcon from '@material-ui/icons/Email';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ContactItem from '../Components/ContactItem';
import LinkedIn from '@material-ui/icons/LinkedIn';
import GithubIcon from '@material-ui/icons/GitHub';
import { Link } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast';

// Add this styled component for the submit button
const SubmitButton = styled.button`
  background-color: #4CAF50; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
  transition-duration: 0.4s;

  &:hover {
    background-color: #45a049;
  }

  &:active {
    transform: scale(0.95);
  }
`;


function ContactPage() {
    const phone = <PhoneIcon />
    const email = <EmailIcon />
    const location = <LocationOnIcon />

    const form = useRef();

    const notify = () => toast("Congratulations ! Message has been sent");

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm('service_u1f5dg6', 'template_uhrwp3g', form.current, 'sf1z61OGwNHEcX_tJ')
      .then((result) => {
          console.log(result.text);
          // Reset the form after successful submission
          form.current.reset();
          // Show the toast notification only after successful submission
          notify();
      }, (error) => {
          console.log(error.text);
      });
  };
    return (
        <MainLayout>
            <Title title={'Contact'} span={'Contact'} />
            <ContactPageStyled >
            <InnerLayout className={'contact-section'}>
                <div className="left-content">
                    <div className="contact-title">
                        <h4>Please drop your info below , I will recieve it on my mail !!  </h4>
                    </div>
                    <form  className="form" ref={form} onSubmit={sendEmail}>
                        <div className="form-field">
                            <label htmlFor="name"  >Enter your name*</label>
                            <input type="text" name="user_name" required />
                        </div>
                        <div className="form-field">
                            <label htmlFor="email"  >Enter your email*</label>
                            <input type="email" name="user_email" required  />
                        </div>
                        <div className="form-field">
                            <label htmlFor="subject"  >Enter your subject</label>
                            <input type="text" name="user_subject" required />
                        </div>
                        <div className="form-field">
                            <label htmlFor="text-area">Enter your Message*</label>
                            <textarea name="message" id="textarea" cols="30" rows="10" required></textarea>
                        </div>
                        <br/>
                        <h3 style={{color: "white"}} ><strong>You will see congratulation message on top  for successful form submission</strong></h3>

                        <div className="form-field f-button">
                        <SubmitButton type="submit">Submit</SubmitButton>
                        <Toaster />
                        </div>
                       
                       
                    </form>
                </div>
                <div className="right-content">
                
                        <GithubIcon />
                    <ContactItem title={'Phone'} icon={phone} cont1={'+91-8126478247'}  />
                    <ContactItem title={'Email'} icon={email} cont1={'sarthak27998@gmail.com'}  />
                    
                </div>
            </InnerLayout>
            </ContactPageStyled>
        </MainLayout>
    )
}


const ContactPageStyled = styled.section`
    .contact-section{
        overflow-x: auto; /* Enable horizontal scrolling */
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        grid-column-gap: 2rem;
        @media screen and (max-width: 978px){
            grid-template-columns: repeat(1, 1fr);
            .f-button{
                margin-bottom: 3rem;
            }
        }
        .right-content{
            display: grid;
            grid-template-columns: repeat(1, 1fr);
            @media screen and (max-width: 502px){
                width: 70%;
            }
        }
        .contact-title{
            h4{
                color: var(--white-color);
                padding: 1rem 0;
                font-size: 1.8rem;
            }
        }
        .form{
            width: 100%;
            @media screen and (max-width: 502px){
                width: 100%;
            }
            .form-field{
                margin-top: 2rem;
                position: relative;
                width: 100%;
                label{
                    position: absolute;
                    left: 20px;
                    top: -19px;
                    display: inline-block;
                    background-color: var(--background-dark-color);
                    padding:0 .5rem;
                    color: inherit;
                }
                input{
                    border: 1px solid var(--border-color);
                    outline: none;
                    background: transparent;
                    height: 50px;
                    padding:0 15px;
                    width: 100%;
                    color: inherit;
                }
                textarea{
                    background-color: transparent;
                    border: 1px solid var(--border-color);
                    outline: none;
                    color: inherit;
                    width: 100%;
                    padding: .8rem 1rem;
                }
            }

            
        }
    }
`;

export default ContactPage
